import React from 'react';

import {
  Container,
  FileNameContainer,
  FileName,
  OpenInNewIcon,
  DeleteIcon,
} from './styles';

interface FileItemProps {
  file: ApiFile;
  onDeleteFile?: (imagePk: number) => void;
  isDeleteDisabled?: boolean;
  dataCy?: string;
}

const FileItem: React.FC<FileItemProps> = ({
  file,
  onDeleteFile,
  isDeleteDisabled,
  dataCy,
}) => {
  return (
    <Container>
      {onDeleteFile && (
        <DeleteIcon
          data-cy={`${dataCy}-delete-button`}
          disabled={isDeleteDisabled}
          onClick={(event) => {
            event.preventDefault();
            onDeleteFile(file.id);
          }}
        />
      )}
      <FileNameContainer
        data-cy={`${dataCy}-link`}
        href={file.path}
        download
        target="_blank"
        rel="noreferrer"
      >
        <FileName>{file.path.split('/')[5]}</FileName>
        <OpenInNewIcon />
      </FileNameContainer>
    </Container>
  );
};

export default FileItem;
